// extracted by mini-css-extract-plugin
export default {"bgLightGrey":"style_bgLightGrey__pdQhZ","bgGrey":"style_bgGrey__nAIsN","minHeight":"style_minHeight__V9Nvz","customWidthHeight":"style_customWidthHeight__zNuIS"};